
import Vue from "vue";
import Api from "@/services/Api";
import { AxiosResponse } from "axios";
import { Overlay } from "@/lib/Overlay";
import { TableOptions } from "@/models/TableOptions";
import moment from "moment";

export interface AfiliadosMovimento {
  data: string;
  pessoa: string;
  valorFormatado: string;
  tipo: string;
  status: string;
}
export default Vue.extend({
  name: "AfiliadosRecebimentos",

  data() {
    return {
      menuInitialDate: false,
      menuFinalDate: false,
      isMobile: false,
      loadingData: true,
      lang: navigator.language,
      errors: [],
      moment: moment,

      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      options: {} as TableOptions,

      headersRecebimentos: [
        { text: "Data", value: "data", sortable: false },
        { text: "Afiliado", value: "pessoa", sortable: false },
        { text: "Valor", value: "valorFormatado", sortable: false },
        { text: "", value: "status", sortable: false },
      ],
      dessertsRecebimentos: new Array<AfiliadosMovimento>(),

      loadingDesserts: false,

      totalDessertsRecebimentos: 0,
      timeout: 0,
      startDate: moment().add(-15, "days").format("YYYY-MM-DD"),
      defaultStartDate: moment().add(-15, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      defaultEndDate: moment().format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),
    };
  },
  created() {
    this.isMobile = this.detectMobile();

    //this.loadAfiliados();
  },

  methods: {
    doDelayedSearchRecebimentos() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        //this is your existing function

        this.loadAfiliadosMovimento();
      }, 1000);
    },

    loadAfiliadosMovimento() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.loadingDesserts = true;
      Overlay.show();
      Api.get("/v2/client/afiliados/movimento", {
        params: {
          startDate: this.startDate,
          endDate: this.endDate,
          page: page,
        },
      })
        .then((response) => {
          this.dessertsRecebimentos = response.data.body
            .rows as AfiliadosMovimento[];
          this.totalDessertsRecebimentos = Number(response.data.body.count);
        })
        .finally(() => {
          Overlay.hide();
          this.loadingDesserts = false;
        });
    },

    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.loadAfiliadosMovimento();
      },
    },
    search: {
      handler() {
        this.doDelayedSearchRecebimentos();
      },
    },
  },
});
